import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Routes, Route } from 'react-router-dom';

import Home from './Component/Home';
import AboutSection from './Component/AboutSection';
import Contact from './Component/Contact';
import Services from './Component/Services';
import NavSection from './Component/NavSection';
import Footer from './Component/Footer';
import Career from './Component/Career';
import NotFound from './Component/NotFound';
import Testimonials from './Component/Testimonials';
import Platfrom from './Component/Platfrom';
import Stats from './Component/Stats';

import './App.css';

function App() {
  return (
    <div>
      <NavSection />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutSection />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services" element={<Services />} />
        <Route path="/career" element={<Career />} />
        <Route path="/Testimonials" element={<Testimonials />} />
        <Route path="/Stats" element={<Stats />} />
        <Route path="/Platfrom" element={<Platfrom />} />
        <Route path="*" element={<NotFound />} />
      </Routes>

      <Footer />
    </div>
  );
}

export default App;